import { css } from '@microsoft/fast-element';
import { MainStyles } from '../../../main/main.styles';

export const UserModalStyles = css`
  ${MainStyles}

  :host {
    --control-corner-radius: 6;
  }

  .user-modal-menu {
    align-items: flex-start;
    flex-direction: column;
    margin-left: 15px;
    margin-top: 15px;
    display: flex;
  }

  .user-modal-menu-item,
  .user-modal-menu-item a {
    margin-bottom: 15px;
    font-size: 14px;
    display: flex;
    gap: 5px;
    align-items: center;
    cursor: pointer;
  }

  .user-modal-menu-item a {
    text-decoration: none;
    color: inherit;
    width: 100%;
  }

  .hyperlink:hover {
    text-decoration: underline;
  }

  .user-modal-rectangle {
    align-items: flex-start;
    flex-direction: column;
    text-align: left;
    padding: 10px;
    width: auto;
    height: 53px;
    background-color: rgb(169 255 120 / 20%);
  }

  .user-modal-roles {
    box-sizing: border-box;
    font-weight: 500;
    font-size: 12px;
  }

  .user-modal-username {
    font-weight: 500;
    font-size: 16px;
    padding-bottom: 5px;
  }

  .zero-select-label {
    width: 115px;
  }
`;
